import templateUrl from 'emun.order/order-quick-view.htm'
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import CartItem from 'emun.cart/cart-item.model'

class controller {
    constructor() { 
        const $ctrl = this;
        basicController($ctrl);
    }
    $onInit(){
        const $ctrl = this;
        const id = $ctrl.order && $ctrl.order.id || $ctrl.orderId;
        $ctrl.bus = new ServiceBus();
        $ctrl.bus.read(`Cart/${id}.json?Take=1`).then(res=> {
            $ctrl.order = Object.assign({},$ctrl.order, res.data.results[0]);
            $ctrl.order.items = $ctrl.order.items.map(item => new CartItem(item));
        });
    }
}


let component = {
    bindings: {
        orderId: '@',
        order: '<?'
    },
    controller,
    templateUrl: ($element, $attrs) =>  $attrs.templateUrl || templateUrl
}

export default component